import { useQuery } from '@hooks/reactQuery';

import { getOrganisationProjectAdmins } from '@api/projectManagement';

import { extractQueryParams } from '@utils/common';
import { projectUsersFormatted } from '@utils/formatter';

import { TNameTitleValueLabel } from '@interfaces/common/common';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { ORGANISATION_PROJECTS_ADMINS } from '@constants/queryKeys';

interface IUseQueryProjectAdminsReturned {
	projectAdmins: TNameTitleValueLabel[];
	isLoadingProjectsAdmins: boolean;
}

export const useQueryOrganisationProjectAdmins = (organizationId?: string): IUseQueryProjectAdminsReturned => {
	const {
		data: projectAdmins,
		isInitialLoading,
		isFetching,
	} = useQuery({
		queryKey: [ORGANISATION_PROJECTS_ADMINS, { organizationId }],
		queryFn: extractQueryParams(getOrganisationProjectAdmins),
		enabled: [organizationId],
		allowedRoles: [
			EUserRoles.assetOwnerOrganizationAdministrator,
			EUserRoles.networkOperatorOrganizationAdministrator,
			EUserRoles.assetConsumerOrganizationAdministrator,
		],
		select: requestTypes => projectUsersFormatted(requestTypes),
		...refetchOptions,
	});

	return {
		projectAdmins: projectAdmins || [],
		isLoadingProjectsAdmins: isInitialLoading || isFetching,
	};
};
